// extracted by mini-css-extract-plugin
export default {"inputCount":"InputCount_inputCount__NZ8HW","label":"InputCount_label__v12US"};